import qc from 'qc'
import * as languageScript from '@ps/bridge/qc/scripts/language'
import { generateLanguageConfigTextByNode, LanguageScript } from '@ps/bridge/qc/scripts/language'
import _ from 'lodash'
import * as editorScript from '@ps/bridge/qc/scripts/editor'
import { Base64 } from 'js-base64'
import store from '@ps/store'
import { getDescendantsText } from '@ps/bridge/qc/node/utils'
import { getLanguagesFromGamePlay } from '@ps/workbench/language'
import { Font, pickFontAndText } from '@com/i18n'
import { Languages } from 'i18n'

export const addLanguageScriptAfterAddTextNode = ({ node, langs }: {
  node: qc.UIText;
  langs: string[]
}): void => {
  const langConf = languageScript.getScript(node) as languageScript.LanguageScript
  // 将 uuid 作为新增的节点多语言脚本中的 langKey
  languageScript.updateLangKey(node, node.uuid)
  langs.forEach(language => {
    const config = generateLanguageConfigTextByNode(node)
    _.set(langConf.langConfig, `${language}.pdef`, Object.assign({}, config))
    _.set(langConf.langConfig, `${language}.ldef`, Object.assign({}, config))
  })
}

/**
 * 复制场景节点时，更新文本节点多语言脚本的 langKey 属性
 * 如果 langKey 的值是 uuid，则复制文本节点时需要用新的 uuid 替换掉
 * @param node clone 出来的节点（引擎的 clone 接口不会处理多语言脚本的 langKey 属性，所以需要自己处理）
 */
export const updateTextNodeLangKeyAfterCloneNode = (node: qc.Node): void => {
  const editorScriptConf = editorScript.getScript(node)
  const langScriptConf = languageScript.getScript(node) as LanguageScript
  if (editorScriptConf) {
    if (editorScriptConf.$data.oldLangKey) {
      // oldLangKey 与 langKey 相同说明该节点保留了导入时用的 langKey，不需要更新
      if (editorScriptConf.$data.oldLangKey === langScriptConf.langKey) {
        // console.log(
        //   'oldLangKey 与 langKey 相同说明该节点保留了导入时用的 langKey，不需要更新'
        // )
      } else {
        // console.log(
        //   'oldLangKey 与 langKey 不一样，说明该 langKey 用了 uuid，需要更新'
        // )
        languageScript.updateLangKey(node, node.uuid)
      }
    } else {
      languageScript.updateLangKey(node, node.uuid)
    }
  }
}

/**
 * 加工文本节点的名字
 * 根据文本节点的个数，添加序号
 */
const productTextNodeName = (): string | undefined => {
  const game = store.state.workspace.game
  const UIRoot = game.UIRoot
  const textNodes = getDescendantsText(UIRoot)
  if (textNodes.length >= 0) {
    const textNodes = getDescendantsText(UIRoot)
    let count = textNodes.length + 1
    while (textNodes.some(node => node.name === `text_${count}`)) {
      count = count + 1
    }
    return `text_${count}`
  }
  return 'text_1'
}

/**
 * 加工文本节点预设数据
 * 文本节点预设是从旧版 ps 导入的
 */
export const cookPrefabBeforeAddInPlayable = (
  files: [
    {
      data: string;
      name: string;
    },
    {
      data: string;
      name: string;
    },
    {
      data: string;
      name: string;
    }
  ]
) => {
  const name = productTextNodeName()

  // bin 文件
  const bin = JSON.parse(Base64.decode(files[0].data))
  const binTextAttrs = JSON.parse(bin[1])
  binTextAttrs.data.name[1] = name
  bin[1] = JSON.stringify(binTextAttrs)
  files[0].data = Base64.encode(JSON.stringify(bin))

  // prefab 文件
  const prefab = Base64.decode(files[2].data)
  const prefabTextAttrs = JSON.parse(prefab)
  prefabTextAttrs.data.name[1] = name
  files[2].data = Base64.encode(JSON.stringify(prefab))

  return _.cloneDeep(files)
}

/**
 * 获取字体对应的文本
 * @param fontName
 * @param text 额外的字符
 */
export function getTextByFont(fontName: string, text?: string): string {
  // 获取到文本配置，用于读取字体
  const languages = getLanguagesFromGamePlay()
  const fonts: Font[] = pickFontAndText(languages as Languages)
  const hasFont = fonts.some(font => font.name === fontName)

  // 先找到原有的字体与对应的文本，判断是否有当前的字体
  // 如果没有则添加字体与文本，如果有则更新该字体的文本
  if (hasFont) {
    const font = fonts.find(font => font.name === fontName)
    if (font) {
      font.text = [
        ...font.text
      ]
      text && font.text.push(text)
    }
  } else {
    if (text) {
      fonts.push({
        name: fontName,
        text: [text]
      })
    }
  }

  // 提取当前字体
  const currentFont = fonts.find(item => item.name === fontName)
  if (currentFont && currentFont.name && !_.isEmpty(currentFont.text)) {
    return currentFont.text.join('').replace(/\s/g, '')
  }
  return ''
}
